import React, {useState} from 'react';
import { Form, InputGroup, Button} from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAlignLeft } from "@fortawesome/free-solid-svg-icons";
import ListGroup from 'react-bootstrap/ListGroup'; 
import {faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import Rightbar from './Rightbar';
import {Link } from 'react-router-dom';


export default function YourProgramming(){ 
    const [sidebar, setsidebar] = useState(false);
    const [mainbar, setmainbar] = useState(false);
    const toggle = () => {
        setsidebar(!sidebar);
        setmainbar(!mainbar);
    }
    return(
  <>
<section className="sec-container" >
   <div className='container'>
      <div className='portalevent'>
         <div className='row'>
         <div className={`col-md-3 portal-sidebar leftbar-close ${sidebar ? 'close' : ''}`}>
                  <div >
                  <Rightbar/>
                  </div>
               </div>
               <div className={`col-md-9 rightbar-open ${mainbar ? 'open' : ''}`}>
                  <div className='rightbar '>
                  <Button variant="outline-info" onClick={toggle}>
                    <FontAwesomeIcon icon={faAlignLeft} />
                  </Button>
            
 
                  <h1>YOUR EXHIBITOR PROGRAMMING</h1>
                            <Form >
                                <Form.Group className="mb-12" controlId="formGroupPassword">
                                    <InputGroup className="mb-6 search">
                                        <InputGroup.Text><FontAwesomeIcon icon={faMagnifyingGlass} /></InputGroup.Text>
                                        <Form.Control type="text" placeholder="search by name..." />
                                    </InputGroup>
                                    <br/>
                                    <div className='text-center'>
                                    <Link to="/exhibitorereateprogramming"><Button className='common-btn'>CREATE PROGRAMMING</Button></Link>
                                    </div>
                                </Form.Group>
                            </Form>
                            <hr />
                            <div className='program-row'>
                            <div className='row'>
                                <div className='col-md-2 '>
                                <img src={process.env.PUBLIC_URL+'/images/default-img.png'}/>
                                </div>
                                <div className='col-md-8'>
                                 <h3>Photo L.A. Virtual Edition 2021</h3>
                                 <div className='row'>
                                    <div className='col-md-4'>
                                    <p><strong>Date:</strong> 2021-09-16</p>
                                    </div>
                                    <div className='col-md-8'>
                                    <p><strong>Date:</strong> 2021-09-16</p>
                                    </div>
                                 </div>
                                 <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                 <h5>Photo L.A. Virtual Edition 2021</h5>
                                </div>
                                <div className='col-md-2 middle-aln'>
                                <Button className='common-btn'>Edit</Button>
                                </div>
                            </div>
                            </div>

                            <div className='program-row'>
                            <div className='row'>
                                <div className='col-md-2 '>
                                <img src={process.env.PUBLIC_URL+'/images/default-img.png'}/>
                                </div>
                                <div className='col-md-8'>
                                 <h3>Photo L.A. Virtual Edition 2021</h3>
                                 <div className='row'>
                                    <div className='col-md-4'>
                                    <p><strong>Date:</strong> 2021-09-16</p>
                                    </div>
                                    <div className='col-md-8'>
                                    <p><strong>Date:</strong> 2021-09-16</p>
                                    </div>
                                 </div>
                                 <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                 <h5>Photo L.A. Virtual Edition 2021</h5>
                                </div>
                                <div className='col-md-2 middle-aln'>
                                <Button className='common-btn'>Edit</Button>
                                </div>
                            </div>
                            </div>
 
                  </div>
            </div>
         </div>
      </div>
   </div>
</section>  

 
</>
)
}
